import { render, staticRenderFns } from "./AuthorDashboardLayout.vue?vue&type=template&id=7fd61a5f"
import script from "./AuthorDashboardLayout.vue?vue&type=script&lang=js"
export * from "./AuthorDashboardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports